<template>
    <div class="widget-component">
        <v-container fluid>
            <v-container class="container-width">
                <v-row>
                    <v-col cols="12">
                        <v-card
                            :loading="loading"
                            class="mx-auto my-12"
                            :width="normalizedOptions.card.width"
                            :elevation="normalizedOptions.card.elevation"
                        >
                            <v-card-text>
                                <v-row
                                    align="center"
                                    class="mx-0"
                                >
                                    <v-col cols="12" class="px-lg-16 py-lg-16">
                                        <v-col cols="12">
                                            <div v-if="normalizedOptions.login.show">
                                                <p>
                                                    {{ normalizedOptions.login.text }}
                                                    <a :href="normalizedOptions.login.url"
                                                       :style="{ color: `${normalizedOptions.login.linkColour}` }">
                                                        {{ normalizedOptions.login.linkText }}
                                                    </a>
                                                </p>
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <h1 class="mb-6 color-primary">
                                                {{ normalizedOptions.title }}
                                            </h1>
                                            <div v-html="normalizedOptions.introHtml"></div>
                                        </v-col>

                                        <v-form
                                            ref="form"
                                            v-model="formValid"
                                            :key="formKey"
                                        >

                                            <v-col cols="12" class="my-0 py-0 input-container"
                                                   v-if="normalizedOptions.fields.firstName.show">
                                                <label
                                                    for="firstNameField"
                                                    v-if="!normalizedOptions.fields.firstName.inlineLabels"
                                                    class="mb-4 font-weight-bold"
                                                >
                                                    {{ normalizedOptions.fields.firstName.label }}
                                                </label>
                                                <v-text-field
                                                    id="firstNameField"
                                                    autofocus
                                                    v-model="firstName"
                                                    :label="normalizedOptions.fields.firstName.inlineLabels ? normalizedOptions.fields.firstName.label : ''"
                                                    outlined
                                                    hide-details="auto"
                                                    class="rounded-0 mb-4"
                                                    :rules="normalizedOptions.fields.firstName.rules"
                                                    :error-messages="getError('firstName')"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="my-0 py-0"
                                                   v-if="normalizedOptions.fields.lastName.show">
                                                <label
                                                    for="lastNameField"
                                                    v-if="!normalizedOptions.fields.lastName.inlineLabels"
                                                    class="mb-4 font-weight-bold"
                                                >
                                                    {{ normalizedOptions.fields.lastName.label }}
                                                </label>
                                                <v-text-field
                                                    id="lastNameField"
                                                    v-model="lastName"
                                                    :label="normalizedOptions.fields.lastName.inlineLabels ? normalizedOptions.fields.lastName.label : ''"
                                                    outlined
                                                    hide-details="auto"
                                                    class="rounded-0 mb-4"
                                                    :rules="normalizedOptions.fields.lastName.rules"
                                                    :error-messages="getError('lastName')"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="my-0 py-0"
                                                   v-if="normalizedOptions.fields.phone.show">
                                                <label
                                                    for="phoneField"
                                                    v-if="!normalizedOptions.fields.phone.inlineLabels"
                                                    class="mb-4 font-weight-bold"
                                                >
                                                    {{ normalizedOptions.fields.phone.label }}
                                                </label>
                                                <v-text-field
                                                    id="phoneField"
                                                    type="phone"
                                                    v-model="phone"
                                                    :label="normalizedOptions.fields.phone.inlineLabels ? normalizedOptions.fields.phone.label : ''"
                                                    outlined
                                                    hide-details="auto"
                                                    class="rounded-0 mb-4"
                                                    :rules="normalizedOptions.fields.phone.rules"
                                                    :error-messages="getError('phone')"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="my-0 py-0">
                                                <label
                                                    for="emailField"
                                                    v-if="!normalizedOptions.fields.email.inlineLabels"
                                                    class="mb-4 font-weight-bold"
                                                >
                                                    {{ normalizedOptions.fields.email.label }}
                                                </label>
                                                <v-text-field
                                                    id="emailField"
                                                    v-model="email"
                                                    :label="normalizedOptions.fields.email.inlineLabels ? normalizedOptions.fields.email.label : ''"
                                                    outlined
                                                    hide-details="auto"
                                                    class="rounded-0 mb-4"
                                                    required
                                                    :rules="normalizedOptions.fields.email.rules"
                                                    :error-messages="getError('email')"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="my-0 py-0">
                                                <label
                                                    for="passwordField"
                                                    v-if="!normalizedOptions.fields.password.inlineLabels"
                                                    class="mb-4 font-weight-bold"
                                                >
                                                    {{ normalizedOptions.fields.password.label }}
                                                </label>
                                                <v-text-field
                                                    id="passwordField"
                                                    v-model="password"
                                                    :label="normalizedOptions.fields.password.inlineLabels ? normalizedOptions.fields.password.label : ''"
                                                    outlined
                                                    hide-details="auto"
                                                    class="rounded-0 mb-4"
                                                    required
                                                    :rules="normalizedOptions.fields.password.rules"
                                                    type="password"
                                                    :type="showPassword ? 'text' : 'password'"
                                                    :append-icon="normalizedOptions.fields.password.enableShowPassword ? showPassword ? 'mdi-eye' : 'mdi-eye-off' : ''"
                                                    @click:append="showPassword = !showPassword"
                                                    :error-messages="getError('password')"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="my-0 py-0 mb-6">
                                                <label
                                                    for="confirmPasswordField"
                                                    v-if="!normalizedOptions.fields.confirmPassword.inlineLabels"
                                                    class="mb-4 font-weight-bold"
                                                >
                                                    {{ normalizedOptions.fields.confirmPassword.label }}
                                                </label>
                                                <v-text-field
                                                    id="confirmPasswordField"
                                                    v-model="confirmPassword"
                                                    :label="normalizedOptions.fields.confirmPassword.inlineLabels ? normalizedOptions.fields.confirmPassword.label : ''"
                                                    outlined
                                                    hide-details="auto"
                                                    class="rounded-0"
                                                    required
                                                    type="password"
                                                    :rules="normalizedOptions.fields.confirmPassword.rules"
                                                    :type="showPassword ? 'text' : 'password'"
                                                    :append-icon="normalizedOptions.fields.confirmPassword.enableShowPassword ? showPassword ? 'mdi-eye' : 'mdi-eye-off' : ''"
                                                    @click:append="showPassword = !showPassword"
                                                    :error-messages="getError('password')"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="my-0 py-0"
                                                   v-if="normalizedOptions.fields.newsSurveysConsent.show">
                                                <v-checkbox
                                                    class="ma-0"
                                                    v-model="newsSurveysConsent"
                                                    :label="normalizedOptions.fields.newsSurveysConsent.label"
                                                    :rules="normalizedOptions.fields.newsSurveysConsent.rules"
                                                ></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" class="my-0 py-0"
                                                   v-if="normalizedOptions.fields.newsletterConsent.show">
                                                <v-checkbox
                                                    class="ma-0"
                                                    v-model="newsletterConsent"
                                                    :label="normalizedOptions.fields.newsletterConsent.label"
                                                    :rules="normalizedOptions.fields.newsletterConsent.rules"
                                                ></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" class="my-0 py-0"
                                                   v-if="normalizedOptions.fields.privacyPolicyAccepted.show">
                                                <v-checkbox
                                                    class="ma-0 pa-0"
                                                    v-model="privacyPolicyAccepted"
                                                    :label="normalizedOptions.fields.privacyPolicyAccepted.label"
                                                    :rules="normalizedOptions.fields.privacyPolicyAccepted.rules"
                                                >
                                                    <template v-slot:label>
                                                        <div>
                                                            {{
                                                                normalizedOptions.fields.privacyPolicyAccepted.label
                                                            }}
                                                            <a
                                                                :style="{'color': normalizedOptions.fields.privacyPolicyAccepted.linkColour}"
                                                                :target="normalizedOptions.fields.privacyPolicyAccepted.urlTarget"
                                                                :href="normalizedOptions.fields.privacyPolicyAccepted.url"
                                                                @click.stop
                                                                v-if="normalizedOptions.fields.privacyPolicyAccepted.linkText && normalizedOptions.fields.privacyPolicyAccepted.url"
                                                            >
                                                                {{
                                                                    normalizedOptions.fields.privacyPolicyAccepted.linkText
                                                                }}
                                                            </a>
                                                        </div>
                                                    </template>
                                                </v-checkbox>
                                            </v-col>
                                            <v-col cols="12" md="8">
                                                <div id="captcha"></div>
                                                <div
                                                    class="v-messages theme--light error--text"
                                                    role="alert"
                                                    v-if="captchaError || (has(errors, 'errors.g-recaptcha-response.0'))">
                                                    <div class="v-messages__wrapper">
                                                        <div class="v-messages__message">
                                                            <span v-if="captchaError">{{
                                                                    normalizedOptions.recaptcha.errorMessage
                                                                }}</span>
                                                            <span v-else>{{
                                                                    errors.errors['g-recaptcha-response'][0]
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md="8">
                                                <v-btn
                                                    color="primary"
                                                    @click="validateForm"
                                                    class="ma-0"
                                                    large
                                                    block
                                                    :loading="loading"
                                                    :disabled="loading"
                                                >
                                                    {{ normalizedOptions.fields.registerButton.text }}
                                                </v-btn>
                                            </v-col>
                                        </v-form>
                                    </v-col>
                                </v-row>

                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
    </div>
</template>

<script>
import {defineComponent, ref, onMounted, computed, nextTick} from "@vue/composition-api";
import {has, isNil, merge, isObject} from "lodash";
import ProfileService from "../services/ProfileService";

export default defineComponent({
    name: "Register",
    components: {},
    props: {
        rootUrl: {
            type: String,
            required: true
        },
        settings: {
            type: Object
        },
        accessToken: {
            type: String
        },
        showTitle: {
            type: Boolean,
            default: true
        }
    },
    setup(props, context) {
        const loading = ref(false);
        const form = ref(null);
        const formValid = ref(false);
        const formKey = ref(0);
        const title = ref(null);
        const firstName = ref(null);
        const lastName = ref(null);
        const phone = ref(null);
        const email = ref(null);
        const password = ref(null);
        const confirmPassword = ref(null);

        const newsletterConsent = ref(null);
        const newsSurveysConsent = ref(null);
        const partnersOffersConsent = ref(null);
        const smsConsent = ref(null);
        const whatsappConsent = ref(null);
        const privacyPolicyAccepted = ref(null);

        const showPassword = ref(false);
        const errors = ref(null);
        const captchaError = ref(false);
        const captchaToken = ref(null);
        const defaultSettings = ref({
            title: 'Create an account',
            introHtml: '<p>We take your privacy seriously and will only use any personal information you ' +
                'share to provide the services and details you have requested from us. ' +
                'We will contact you by Email, Text or Telephone, but let us know if you have a preference.</p>',
            recaptcha: {
                enabled: false,
                errorMessage: 'Please confirm you are not a robot'
            },
            card: {
                width: 622,
                elevation: 5
            },
            login: {
                show: true,
                text: 'Already have an account?',
                textColour: '#000',
                linkText: 'Login here',
                linkColour: 'blue',
                url: '/login'
            },
            fields: {
                firstName: {
                    show: true,
                    inlineLabels: false,
                    label: 'First Name*',
                    rules: [
                        v => !!v || 'First name is required'
                    ]
                },
                lastName: {
                    show: true,
                    inlineLabels: false,
                    label: 'Last Name*',
                    rules: [
                        v => !!v || 'Last name is required'
                    ]
                },
                phone: {
                    show: true,
                    inlineLabels: false,
                    label: 'Phone number*',
                    rules: [
                        v => !!v || 'Phone number is required',
                        v => /^[0-9]*$/.test(v) || 'Please enter a valid phone number'
                    ]
                },
                email: {
                    inlineLabels: false,
                    label: 'Email Address*',
                    rules: [
                        v => !!v || 'Email address is required'
                    ]
                },
                password: {
                    inlineLabels: false,
                    enableShowPassword: false,
                    label: 'Password*',
                    rules: [
                        v => !!v || 'Password field is required'
                    ]
                },
                confirmPassword: {
                    inlineLabels: false,
                    enableShowPassword: false,
                    label: 'Confirm Password*',
                    rules: [
                        v => !!v || 'Confirm password field is required',
                        v => v === password.value || 'The password confirmation does not match.'
                    ]
                },
                newsSurveysConsent: {
                    show: true,
                    label: 'Do you wish to receive notifications about other homes we think you maybe interested in based on your current preferences.',
                    rules: []
                },
                newsletterConsent: {
                    show: true,
                    label: 'Do you wish to receive our newsletter?',
                    rules: []
                },
                privacyPolicyAccepted: {
                    show: true,
                    label: 'I agree to the ',
                    linkText: 'privacy policy',
                    linkColour: 'blue',
                    url: '/privacy-policy',
                    urlTarget: '_blank',
                    rules: [
                        v => !!v || 'You must accept the Privacy Policy',
                    ]
                },
                registerButton: {
                    show: true,
                    text: 'Create Account'
                }
            },
            events: {
                redirectAfterRegistration: '/dashboard'
            }
        });

        const normalizedOptions = computed(() => {
            return merge(defaultSettings.value, props.settings);
        });

        const captchaEnabled = computed(() => {
            if (has(window, 'kproDataLayer.settings.recaptchaSiteKey') &&
                normalizedOptions.value.recaptcha.enabled &&
                (typeof grecaptcha !== 'undefined')) {
                return true;
            }
            return false;

        });

        function getError(field) {
            const fieldToSearch = 'errors.' + field + '[0]';
            if (has(errors.value, fieldToSearch)) {
                return errors.value.errors[field][0];
            }
            return null
        }

        function buildPayload() {
            const payload = {
                email: email.value,
                password: password.value,
            };
            if (has(normalizedOptions.value, 'fields.title.show') && normalizedOptions.value.fields.title.show) {
                payload.title = title.value;
            }
            if (has(normalizedOptions.value, 'fields.firstName.show') && normalizedOptions.value.fields.firstName.show) {
                payload.firstName = firstName.value;
            }
            if (has(normalizedOptions.value, 'fields.lastName.show') && normalizedOptions.value.fields.lastName.show) {
                payload.lastName = lastName.value;
            }
            if (has(normalizedOptions.value, 'fields.phone.show') && normalizedOptions.value.fields.phone.show) {
                payload.phone = phone.value;
            }
            if (has(normalizedOptions.value, 'fields.newsSurveysConsent.show') && normalizedOptions.value.fields.newsSurveysConsent.show) {
                payload.newsSurveysConsent = newsSurveysConsent.value;
            }
            if (has(normalizedOptions.value, 'fields.newsletterConsent.show') && normalizedOptions.value.fields.newsletterConsent.show) {
                payload.newsletterConsent = newsletterConsent.value;
            }
            if (has(normalizedOptions.value, 'fields.privacyPolicyAccepted.show') && normalizedOptions.value.fields.privacyPolicyAccepted.show) {
                payload.privacyPolicyAccepted = privacyPolicyAccepted.value;
            }

            if (captchaEnabled.value === true) {
                payload['g-recaptcha-response'] = captchaToken.value;
            }

            return payload;
        }

        function validateForm() {
            captchaError.value = false;
            captchaToken.value = null;
            let valid = form.value.validate();

            if (captchaEnabled.value === true) {
                const captchaResponse = getCaptchaResponse();
                if (captchaResponse.length == 0) {
                    captchaError.value = true;
                    valid = false;
                } else {
                    captchaToken.value = captchaResponse;
                }
            }

            if (valid) {
                submitForm()
            } else {
                nextTick(() => {
                    const target = document.querySelector(".v-messages.error--text:first-of-type");
                    scrollToElement(target, 300, 72);
                })
            }
        }

        function submitForm() {
            loading.value = true;
            errors.value = null;
            const payload = buildPayload();
            ProfileService.register(payload)
                .then(function (response) {
                    if (has(normalizedOptions.value, 'events.redirectAfterRegistration')) {
                        window.location.href = normalizedOptions.value.events.redirectAfterRegistration;
                    }
                })
                .catch(function (error) {
                    errors.value = error.response.data;
                })
                .then(function () {
                    loading.value = false;
                });
        }

        function scrollToElement(target, duration = 300, offset = 0, easing = 'easeInOutCubic') {
            if (isNil(target)) {
                return;
            }
            let options = {
                duration: duration,
                offset: offset,
                easing: easing,
            }
            context.root.$vuetify.goTo(target, options);
        }

        onMounted(() => {
            init();
        });

        function getCaptchaResponse(captchaId = undefined) {
            return grecaptcha.getResponse(captchaId);
        }

        function initCaptcha() {
            grecaptcha.render('captcha', {
                'sitekey': window.kproDataLayer.settings.recaptchaSiteKey
            });
        }

        function init() {
            loading.value = false;
            if (captchaEnabled.value === true) {
                initCaptcha();
            }
        }


        return {
            // Variables
            form,
            formValid,
            formKey,
            normalizedOptions,
            loading,
            title,
            firstName,
            lastName,
            phone,
            email,
            password,
            confirmPassword,
            newsletterConsent,
            newsSurveysConsent,
            partnersOffersConsent,
            smsConsent,
            whatsappConsent,
            privacyPolicyAccepted,
            showPassword,
            errors,
            captchaError,
            // Functions
            validateForm,
            submitForm,
            getError,
            has
        };
    }
});
</script>
